'use strict';

angular.module('app.common')

.directive('sliderBanners', [ '$document', '$timeout', function($document, $timeout) {
	function link(scope, element, attrs) {
		$timeout(function() {
			angular.element($document).foundation({
				orbit : {
					bullets : false,
					slide_number : false
				}
			});
		}, 0);
	}

	return {
		restrict: 'E',
		scope: {
			banners: '=',
		},
		templateUrl: 'app/common/directives/sliderbanners/sliderBannersDirective.html',
		link: link
	}
} ]);



// WEBPACK FOOTER //
// ./app/common/directives/sliderbanners/sliderBannersDirective.js